import React from "react";
import PendingRequests from "../components/pendingRequests";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const PendingRequest: React.FC = () => {
 
  const requests:any = useSelector((state: RootState) => state.requests.data);

  const handleYearChange = (year: string) => {
    console.log("Fetch data for year:", year);
    // Call API to fetch data for the selected year
  };

  return (
    <div style={{ background: 'rgb(236, 239, 241)', padding: 30, paddingTop: 100, paddingBottom: 80 }}>
      <PendingRequests  onYearChange={handleYearChange} showHeaderActions={true} />
    </div>
  );
};

export default PendingRequest;